import React, { useEffect, useState } from 'react'
import showDeviceApi from '../../services/showDeviceApi'
import MainCard from '../../ui-component/cards/MainCard';
import { DataGrid } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import CustomLoader from '../../ui-component/CustomLoader';
import tableTheme from "../../ui-component/customTableUi";
import { ThemeProvider } from "@mui/material/styles";
import {
  Stack,
  Button,
  TextField,
  Grid,
  MenuItem,
} from "@mui/material";

import FilterListIcon from "@mui/icons-material/FilterList";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import ClearIcon from "@mui/icons-material/Clear";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
const ActivatedDeviceReport = () => {
  const [activatedDevices, setActivatedDevices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(100); // Default to 100 rows
  const [page, setPage] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const defaultFilters = {
  device_esn: "",
  imei: "",
  iccid: "",
  vehicle_reg_no: "",
  vehicle_owner_name: "",
  vehicle_owner_company: "",
  vehicle_owner_mobile_no: "",
  manufacturer_name: "",
  manufacturer_state: "",
  dealer_name: "",
  dealer_mobile_no: "",
  district_code: "",
  state_id: "",
  device_model_name: "",
  vehicle_make: "",
  vehicle_model: "",
  vehicle_category: "",
  telecom_provider1: "",
  telecom_provider2: "",
  vendor_id: "",
  tac_no: "",
  stock_status: "",
  esim_status: "",
  fitment_status: "",
  fitment_date: "",
  fitment_date_from: "",
  fitment_date_to: "",
  created_date: "",
  created_date_from: "",
  created_date_to: "",
  device_assigned_date: "",
  device_assigned_date_from: "",
  device_assigned_date_to: "",
  esim_validity: "",
  esim_validity_from: "",
  esim_validity_to: "",
};

const [filters, setFilters] = useState(defaultFilters);

const [search, setSearch] = useState("");

const [openFilter, setOpenFilter] = useState(false);

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleString('en-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });
  };

  const columns = [
    {
      field: 'device_esn',
      headerName: 'Device ESN',
      minWidth: 150,
      flex: 1,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
          {params.value}
        </div>
      )
    },
    {
      field: 'imei',
      headerName: 'IMEI',
      minWidth: 150,
      flex: 1
    },
    {
      field: 'vehicle_reg_no',
      headerName: 'Vehicle Reg No',
      minWidth: 120,
      flex: 1
    },
    {
      field: 'iccid',
      headerName: 'ICCID',
      minWidth: 200,
      flex: 1
    },
    {
      field: 'msisdn1',
      headerName: 'MSISDN 1',
      minWidth: 120,
      flex: 1
    },
    {
      field: 'msisdn2',
      headerName: 'MSISDN 2',
      minWidth: 120,
      flex: 1
    },
    {
      field: 'fitment_date',
      headerName: 'Fitment Date',
      minWidth: 180,
      flex: 1,
      valueFormatter: (params) => formatDate(params.value)
    },
    {
      field: 'fitment_status',
      headerName: 'Fitment Status',
      minWidth: 180,
      flex: 1,
      renderCell: (params) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          color: params.value === 'Owner_Final_OTP_Verified' ? 'green' : 'inherit'
        }}>
          {params.value?.replace(/_/g, ' ')}
        </div>
      )
    },
    {
      field: 'esim_validity',
      headerName: 'ESIM Validity',
      minWidth: 120,
      flex: 1,
      valueFormatter: (params) => formatDate(params.value)
    },
    {
      field: 'telecom_provider1',
      headerName: 'Telecom Provider 1',
      minWidth: 150,
      flex: 1
    },
    {
      field: 'telecom_provider2',
      headerName: 'Telecom Provider 2',
      minWidth: 150,
      flex: 1
    },
    {
      field: 'stock_status',
      headerName: 'Stock Status',
      minWidth: 120,
      flex: 1,
      renderCell: (params) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          color: params.value === 'Fitted' ? 'green' : 'inherit'
        }}>
          {params.value}
        </div>
      )
    },
    {
      field: 'esim_status',
      headerName: 'ESIM Status',
      minWidth: 180,
      flex: 1,
      renderCell: (params) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          color: params.value === 'ESIM_Active_Confirmed' ? 'green' : 'inherit'
        }}>
          {params.value?.replace(/_/g, ' ')}
        </div>
      )
    },
    {
      field: 'engine_no',
      headerName: 'Engine No',
      minWidth: 150,
      flex: 1
    },
    {
      field: 'chassis_no',
      headerName: 'Chassis No',
      minWidth: 180,
      flex: 1
    },
    {
      field: 'vehicle_make',
      headerName: 'Vehicle Make',
      minWidth: 180,
      flex: 1
    },
    {
      field: 'vehicle_model',
      headerName: 'Vehicle Model',
      minWidth: 120,
      flex: 1
    },
    {
      field: 'vehicle_category',
      headerName: 'Vehicle Category',
      minWidth: 150,
      flex: 1
    },
    {
      field: 'dto_district_code',
      headerName: 'DTO District Code',
      minWidth: 150,
      flex: 1
    },
    {
      field: 'district_name',
      headerName: 'District Name',
      minWidth: 150,
      flex: 1
    },
    {
      field: 'state_name',
      headerName: 'State Name',
      minWidth: 120,
      flex: 1
    },
    {
      field: 'vehicle_owner_name',
      headerName: 'Vehicle Owner Name',
      minWidth: 180,
      flex: 1
    },
    {
      field: 'device_model_name',
      headerName: 'Device Model Name',
      minWidth: 180,
      flex: 1
    },
    {
      field: 'hardware_version',
      headerName: 'Hardware Version',
      minWidth: 150,
      flex: 1
    },
    {
      field: 'vendor_id',
      headerName: 'Vendor ID',
      minWidth: 120,
      flex: 1
    },
    {
      field: 'tac_no',
      headerName: 'TAC No',
      minWidth: 120,
      flex: 1
    },
    {
      field: 'manufacturer_name',
      headerName: 'Manufacturer Name',
      minWidth: 180,
      flex: 1
    },
    {
      field: 'manufacturer_user_name',
      headerName: 'Manufacturer User Name',
      minWidth: 200,
      flex: 1
    },
    {
      field: 'manufacturer_state',
      headerName: 'Manufacturer State',
      minWidth: 150,
      flex: 1
    },
    {
      field: 'dealer_name',
      headerName: 'Dealer Name',
      minWidth: 180,
      flex: 1
    },
    {
      field: 'dealer_user_name',
      headerName: 'Dealer User Name',
      minWidth: 180,
      flex: 1
    },
    {
      field: 'tagged_by_name',
      headerName: 'Tagged By Name',
      minWidth: 180,
      flex: 1
    },
    {
      field: 'tagged_by_email',
      headerName: 'Tagged By Email',
      minWidth: 200,
      flex: 1
    },
    {
      field: 'created_date',
      headerName: 'Created Date',
      minWidth: 180,
      flex: 1,
      valueFormatter: (params) => formatDate(params.value)
    },
    {
      field: 'device_assigned_date',
      headerName: 'Device Assigned Date',
      minWidth: 180,
      flex: 1,
      valueFormatter: (params) => formatDate(params.value)
    }
  ];

  useEffect(() => {
    fetchActivatedDevices();
  }, [page, pageSize]);

 const fetchActivatedDevices = async (
  payload = defaultFilters,
  pageNo = page + 1,
  pageLimit = pageSize
) => {
  try {
    setLoading(true);

    const response = await showDeviceApi.getActivatedDeviceList({
      ...payload,
      page: pageNo,
      page_size: pageLimit,
    });

    if (response.data.status === "success") {
      const devices = response.data.data.devices.map((item) => ({
        ...item,
        id: item.id,
      }));

      setActivatedDevices(devices);

      setTotalRows(response.data.data.total_count);
    }
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  const timer = setTimeout(() => {
    fetchActivatedDevices({
      ...filters,
      device_esn: search,
    });
  }, 500);

  return () => clearTimeout(timer);
}, [search]);

const applyFilter = () => {
  fetchActivatedDevices(filters);
  setOpenFilter(false);
};

const clearFilter = () => {
  setFilters(defaultFilters);

  setSearch("");

  fetchActivatedDevices(defaultFilters);
};

const downloadExcel = async () => {

  const response = await showDeviceApi.getActivatedDeviceList({
    ...filters,
    device_esn: search,
    page: 1,
    page_size: totalRows || 100000,
  });

  const data = response.data.data.devices;

  const worksheet = XLSX.utils.json_to_sheet(data);

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "Activated Devices"
  );

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  saveAs(
    new Blob([excelBuffer]),
    "ActivatedDevices.xlsx"
  );
};

const printActivatedDevices = async () => {

  const response = await showDeviceApi.getActivatedDeviceList({
    ...filters,
    device_esn: search,
    page: 1,
    page_size: totalRows || 100000,
  });

  const data = response.data.data.devices;

  const html = `
  <html>
  <head>
    <title>Activated Devices</title>

    <style>
      body{
        font-family:Arial;
        padding:20px;
      }

      table{
        width:100%;
        border-collapse:collapse;
      }

      th,td{
        border:1px solid #000;
        padding:6px;
        font-size:12px;
      }

      th{
        background:#f2f2f2;
      }
    </style>

  </head>

  <body>

  <h2>Activated Device Report</h2>

  <table>

  <tr>
    <th>ESN</th>
    <th>IMEI</th>
    <th>Vehicle</th>
    <th>Owner</th>
    <th>Manufacturer</th>
    <th>Dealer</th>
    <th>Status</th>
  </tr>

  ${data.map(item=>`

    <tr>
      <td>${item.device_esn||""}</td>
      <td>${item.imei||""}</td>
      <td>${item.vehicle_reg_no||""}</td>
      <td>${item.vehicle_owner_name||""}</td>
      <td>${item.manufacturer_name||""}</td>
      <td>${item.dealer_name||""}</td>
      <td>${item.fitment_status||""}</td>
    </tr>

  `).join("")}

  </table>

  </body>
  </html>
  `;

  const win = window.open("", "_blank");

  win.document.write(html);

  win.document.close();

  win.print();

  win.close();
};



  return (
    <ThemeProvider theme={tableTheme}>
      <MainCard title="Activated Device Report">
        {loading ? (
          <CustomLoader />
        ) : (
          <Box sx={{
            width: '100%',
            height: 'calc(100vh - 200px)',
            // '& .MuiDataGrid-root': {
            //   border: 'none',
            //   '& .MuiDataGrid-cell': {
            //     borderBottom: '1px solid #e0e0e0'
            //   },
            //   '& .MuiDataGrid-columnHeaders': {
            //     backgroundColor: '#f5f5f5',
            //     borderBottom: '2px solid #e0e0e0'
            //   },
            //   '& .MuiDataGrid-virtualScroller': {
            //     backgroundColor: '#fff'
            //   }
            // }
          }}>
            <Stack
  direction="row"
  spacing={2}
  justifyContent="space-between"
  sx={{ mb: 2 }}
>

  <TextField
    size="small"
    placeholder="Search Device ESN"
    value={search}
    onChange={(e)=>setSearch(e.target.value)}
    sx={{width:300}}
  />

  <Stack direction="row" spacing={2}>

    <Button
      variant="outlined"
      startIcon={<FilterListIcon />}
      onClick={()=>setOpenFilter(!openFilter)}
    >
      Filter
    </Button>

    <Button
      variant="outlined"
      color="success"
      startIcon={<DownloadIcon />}
      onClick={downloadExcel}
    >
      Download
    </Button>

    <Button
      variant="outlined"
      color="primary"
      startIcon={<PrintIcon />}
      onClick={printActivatedDevices}
    >
      Print
    </Button>

    <Button
      variant="outlined"
      color="error"
      startIcon={<ClearIcon />}
      onClick={clearFilter}
    >
      Clear
    </Button>

  </Stack>

</Stack>
{openFilter && (
  <Grid
    container
    spacing={2}
    sx={{
      mb: 2,
      mt: 1,
      p: 2,
      border: "1px solid #ddd",
      borderRadius: 2,
      backgroundColor: "#fafafa",
    }}
  >
    <Grid item xs={12} md={3}>
      <TextField
        fullWidth
        label="Device ESN"
        value={filters.device_esn}
        onChange={(e) =>
          setFilters({
            ...filters,
            device_esn: e.target.value,
          })
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        fullWidth
        label="IMEI"
        value={filters.imei}
        onChange={(e) =>
          setFilters({
            ...filters,
            imei: e.target.value,
          })
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        fullWidth
        label="Vehicle No"
        value={filters.vehicle_reg_no}
        onChange={(e) =>
          setFilters({
            ...filters,
            vehicle_reg_no: e.target.value,
          })
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        fullWidth
        label="Manufacturer"
        value={filters.manufacturer_name}
        onChange={(e) =>
          setFilters({
            ...filters,
            manufacturer_name: e.target.value,
          })
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        fullWidth
        label="Manufacturer State"
        value={filters.manufacturer_state}
        onChange={(e) =>
          setFilters({
            ...filters,
            manufacturer_state: e.target.value,
          })
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        fullWidth
        label="Dealer"
        value={filters.dealer_name}
        onChange={(e) =>
          setFilters({
            ...filters,
            dealer_name: e.target.value,
          })
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        select
        fullWidth
        label="Fitment Status"
        value={filters.fitment_status}
        onChange={(e) =>
          setFilters({
            ...filters,
            fitment_status: e.target.value,
          })
        }
      >
        <MenuItem value="">All</MenuItem>
        <MenuItem value="Owner_Final_OTP_Verified">
          Owner Final OTP Verified
        </MenuItem>
      </TextField>
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        type="date"
        fullWidth
        label="Fitment From"
        InputLabelProps={{ shrink: true }}
        value={filters.fitment_date_from}
        onChange={(e) =>
          setFilters({
            ...filters,
            fitment_date_from: e.target.value,
          })
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        type="date"
        fullWidth
        label="Fitment To"
        InputLabelProps={{ shrink: true }}
        value={filters.fitment_date_to}
        onChange={(e) =>
          setFilters({
            ...filters,
            fitment_date_to: e.target.value,
          })
        }
      />
    </Grid>

    <Grid item xs={12}>
      <Stack direction="row" justifyContent="flex-end" spacing={2}>
        <Button
          variant="outlined"
          onClick={clearFilter}
        >
          Clear
        </Button>

        <Button
          variant="contained"
          onClick={applyFilter}
        >
          Apply Filter
        </Button>
      </Stack>
    </Grid>
  </Grid>
)}
            <DataGrid
              rows={activatedDevices}
              columns={columns}
              pageSize={pageSize}
              page={page}
              rowCount={totalRows}
              onPageChange={(newPage) => setPage(newPage)}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[10, 25, 50, 100]}
              pagination
              paginationMode="server"
              disableSelectionOnClick
              getRowHeight={() => 'auto'}
              // sx={{
              //   '& .MuiDataGrid-cell': {
              //     padding: '8px',
              //     alignItems: 'center'
              //   },
              //   '& .MuiDataGrid-columnHeader': {
              //     padding: '8px',
              //     fontWeight: 'bold'
              //   }
              // }}
              sx={{
                border: "none",
                borderRadius: "12px",

                // HEADER (NOW WILL WORK)
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#0f172a",
                  color: "#ffffff",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderBottom: "2px solid #334155",
                },

                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "600",
                },

                // ROWS
                "& .MuiDataGrid-row:nth-of-type(even)": {
                  backgroundColor: "#f8fafc",
                },

                "& .MuiDataGrid-row:hover": {
                  backgroundColor: "#e2e8f0",
                },

                // CELLS
                "& .MuiDataGrid-cell": {
                  borderBottom: "1px solid #e2e8f0",
                  fontSize: "13px",
                  padding: "12px",
                  alignItems: "center",
                },

                // FOOTER
                "& .MuiDataGrid-footerContainer": {
                  backgroundColor: "#f1f5f9",
                },
              }}
            />
          </Box>
        )}
      </MainCard>
    </ThemeProvider>
  );
};

export default ActivatedDeviceReport;
